import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import PropTypes from 'prop-types';
import { homePathByRole } from 'common/constants/general';

function Gate({ allowedRoles, children }) {
  const navigate = useNavigate();
  const user = useSelector((state) => state.auth.user);

  // Aquí SOLO se decide por rol. La ausencia de sesión la resuelve `Authenticated`, que envuelve a
  // este componente y además sabe preservar el destino con `?redirect=`.
  //
  // Antes ambos redirigían cuando no había usuario: con `user = null` (el estado inicial, y también
  // el que deja el purgado del store al caducar la sesión) los dos lanzaban su navegación en el
  // mismo ciclo, se pisaban y apilaban entradas en el historial. Ese era el "entrar y salir" que se
  // veía en pantalla.
  useEffect(() => {
    if (user && !allowedRoles.includes(user.role)) {
      const homePath = homePathByRole[user.role] || homePathByRole.default;
      navigate(homePath, { replace: true });
    }
  }, [user, navigate, allowedRoles]);

  return user && children;
}

Gate.propTypes = {
  allowedRoles: PropTypes.arrayOf(PropTypes.string).isRequired,
  children: PropTypes.element.isRequired
};

export default Gate;
